import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import MobileMenu from "./../open_data/MobileMenuOpenData"; // pastikan path-nya sesuai

const HeaderComponentOpenData = () => {
    const location = useLocation();
    const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

    const toggleNav = () => {
        setIsMobileNavOpen(!isMobileNavOpen);
    };

    const closeMobileNav = () => {
        if (isMobileNavOpen) {
            setIsMobileNavOpen(false);
        }
    };

    return (
        <>
            <header id="header" className="fixed-top header-transparent">
                <div className="container d-flex align-items-center justify-content-between">
                    <div className="logo">
                        <Link to="/open_data">
                            <img
                                src={`${process.env.PUBLIC_URL}/sampang.png`}
                                alt="Sampang"
                            />
                        </Link>
                    </div>

                    {/* Desktop Navigation */}
                    <nav id="navbar" className="navbar d-none d-lg-block">
                        <ul>
                            <li>
                                <Link
                                    to="/open_data"
                                    className={`nav-link scrollto ${location.pathname === "/open_data" ? "active" : ""
                                        }`}
                                >
                                    Beranda
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/open_data/kumpulan_data"
                                    className={`nav-link scrollto ${location.pathname === "/open_data/kumpulan_data"
                                            ? "active"
                                            : ""
                                        }`}
                                >
                                    Kumpulan Data
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/open_data/organisasi"
                                    className={`nav-link scrollto ${location.pathname === "/open_data/organisasi" ? "active" : ""
                                        }`}
                                >
                                    Organisasi
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/open_data/kategori"
                                    className={`nav-link scrollto ${location.pathname === "/open_data/kategori" ? "active" : ""
                                        }`}
                                >
                                    Kategori
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/open_data/infografik"
                                    className={`nav-link scrollto ${location.pathname === "/open_data/infografik" ? "active" : ""
                                        }`}
                                >
                                    Infografik
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/open_data/tentang"
                                    className={`nav-link scrollto ${location.pathname === "/open_data/tentang" ? "active" : ""
                                        }`}
                                >
                                    Tentang
                                </Link>
                            </li>
                        </ul>
                    </nav>

                    {/* Mobile Toggle (hanya terlihat di layar kecil) */}
                    <i
                        className={`bi mobile-nav-toggle d-lg-none ${isMobileNavOpen ? "bi-x" : "bi-list"
                            }`}
                        onClick={toggleNav}
                    ></i>
                </div>
            </header>

            {/* Render MobileMenu menggunakan Portal */}
            <MobileMenu
                isOpen={isMobileNavOpen}
                closeMenu={closeMobileNav}
                location={location}
            />
        </>
    );
};

export default HeaderComponentOpenData;
